<template>
  <main>
    <b-row>
      <b-col lg="6" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/rank-sales')" icon="BarChart2Icon" color="primary" :statistic="cardSales" statistic-title="Rank Sales" />
      </b-col>
      <b-col lg="6" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/karyawan')" icon="UsersIcon" color="success" :statistic="cardKaryawan" statistic-title="Total Karyawan" />
      </b-col>
    </b-row>
  </main>
</template>
<script>
import { BAlert } from "bootstrap-vue";
import { BTabs, BTab, BRow, BCol, BCard } from "bootstrap-vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";

export default {
  data() {
    return {
      card: {},
    };
  },
  components: {
    StatisticCardHorizontal,
    BAlert,
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard,
  },
  computed: {
    myName() {
      if (this.user) {
        return this.user.karyawan ? this.user.karyawan.nama_lengkap : this.user.email;
      }

      return null;
    },
    cardSales() {
      return this.card.sales + " Orang";
    },
    cardKaryawan() {
      return this.card.karyawan + " Orang";
    },
  },
  methods: {
    postCardInfo() {
      let payload = {
        show: {
          penjualan: false,
          sales: true,
          karyawan: true,
          collection: false,
          assetTotal: false,
          assetNilai: false,
          barangMobilNilai: false,
          keuntungan: false,
        },
      };

      this.$store
        .dispatch("dashboard/cardInfo", payload)
        .then((res) => {
          this.card = res;
        })
        .catch((e) => console.error(e));
    },
  },
  mounted() {
    this.postCardInfo();
  },
};
</script>
